// CallRail number swap. Loaded only after React has hydrated: the swap
// rewrites phone-number text, and doing that before hydration makes React
// throw away the server HTML and re-render the page (the hero fades in
// twice), or put the original number back.
const CALLRAIL_SRC = '//cdn.callrail.com/companies/466945511/9f95cd490daae08c921b/12/swap.js'

exports.onInitialClientRender = () => {
  const s = document.createElement('script')
  s.src = CALLRAIL_SRC
  s.async = true
  document.body.appendChild(s)
}

// Logs when the client route changes
exports.onRouteUpdate = ({ location, prevLocation }) => {
  var referrer = document.referrer;

  //if landing URL does not exist in local storage, set current pathname
  if (typeof window !== 'undefined' && window.localStorage && !window.localStorage.getItem('lNdUrL')) {
    window.localStorage.setItem('lNdUrL', location.href)
    window.localStorage.setItem('lNdUrLDtIme', new Date())
  }

  window.localStorage.setItem('crNtPaTH', location.href)
  window.localStorage.setItem('prevPaTHnAme', prevLocation ? prevLocation.href : null)

  // Re-swap tracked numbers after client-side navigation
  window.CallTrk && window.CallTrk.swap()



}